export default __webpack_public_path__ + "static/media/faq.1a342da3.svg";